import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import {
  ResiduosGestionadosControllerService,
  ResiduosGestionadosFilterDTO,
  PageDTOResiduosGestionadosDTO,
  PageDTOGestoresResiduosDTO,
  GestoresConAcuerdoControllerService,
  GestoresConAcuerdoFilterDTO,
  AcuerdoIndirectoControllerService,
  GestoresResiduosControllerService,
  GestionResiduosFilterDTO,
} from 'api-rest';
import { ResiduosGestionadosDTO } from 'api-rest';
import { SnackbarService } from '../../services/snackbar.service';
import { SpinnerService } from '../../services/spinner.service';
import { ManagersAgreementsAddModalComponent } from '../managers-agreements-add-modal/managers-agreements-add-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { IndirectAgreementAddManagerModalComponent } from '../indirect-agreement-add-manager-modal/indirect-agreement-add-manager-modal.component';
import Swal from 'sweetalert2';
import { IdEntityDTO } from '../../../../../dist/api-rest/api-acuerdosgestores/model/idEntityDTO';

@Component({
  selector: 'managers-agreements-indirect-managers-agreements',
  templateUrl: './indirect-managers-agreements.component.html',
  styleUrls: ['./indirect-managers-agreements.component.scss']
})
export class IndirectManagersAgreementsComponent implements OnInit, OnChanges {

  @Input() acuerdoIndirectoInfo!: any;
  @Output() public refrescarAdheridoEvent = new EventEmitter<any>();

  pageNumber: number = 1;
  pageSize: number = 25;
  recordsTotal: number = 0;

  itemsPerPageOptions: number[] = [25, 50, 75, 100];
  selectedItemsPerPage: number = 25;

  gridArray: ResiduosGestionadosDTO[] = [];

    headArray: any = [
      {
      Head: 'Id gestor',
      FieldName: 'id',
              },
        {
      Head: 'Razón social',
      FieldName: 'razonSocial',
    }, 
    
    {
      Head: 'Centro',
      FieldName: 'centro',
    },
    {
      Head: 'Nima',
      FieldName: 'nima',
    },
{
      Head: 'Acciones',
      FieldName: 'actions',
      buttons: [
        { nameButton: 'delete', icon: 'delete', toolTip: 'Borrar', show: { params: 'canAccessDelete', accion: 'delete' } },
      ],
      width: '10',
    },
    // {
    //   Head: 'Descripción código LER',
    //   FieldName: 'codigoLer',
    //   Attribute: 'descripcion',
    //   Tooltip: true,
    // },

    // {
    //   Head: 'Cantidad anual autorizada',
    //   FieldName: 'cantidadAnualAutorizada',
    // },
    // {
    //   Head: 'Fecha desde',
    //   FieldName: 'fechaDesde',
    // },
    // {
    //   Head: 'Fecha hasta',
    //   FieldName: 'fechaHasta',
    // },
    // {
    //   Head: 'Activa',
    //   FieldName: 'autorizacionActiva',
    //   renderValue: (item: any) => (item.autorizacionActiva ? 'SI' : 'NO'),
    // },
  ];

  constructor(
    @Inject(GestoresConAcuerdoControllerService)
    private gestoresConAcuerdoController: GestoresConAcuerdoControllerService,
    @Inject(AcuerdoIndirectoControllerService)
    private acuerdoIndirectoControllerService: AcuerdoIndirectoControllerService,
    @Inject(GestoresResiduosControllerService)
    private gestoresResiduosService: GestoresResiduosControllerService,
    private spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService,
    public dialog: MatDialog,
  ) {
  }

    ngOnInit(): void {
      this.buscarGestores();
    }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['acuerdoIndirectoInfo']?.currentValue) {
      this.buscarGestores();
    }
  }

  private addActionsPermission(list: any[]): any[] {
    const canDelete = this.acuerdoIndirectoInfo?.estado?.id === 1;
    return (list ?? []).map((item: any) => ({ ...item, canAccessDelete: canDelete }));
  }

  buscarGestores() {

    if (!this.acuerdoIndirectoInfo?.id) {
      this.gridArray = [];
      this.recordsTotal = 0;
      return;
    }
    this.gridArray = this.addActionsPermission(this.acuerdoIndirectoInfo.gestoresResiduos ?? []);
    // const filtro: GestoresConAcuerdoFilterDTO = {
      
    // };

    // const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;
    //   this.spinnerSrv.loadingShow();

    // this.gestoresConAcuerdoController
    //   .findAllGestoresConAcuerdo(filtro, { page: page, size: this.pageSize, sort: ['id,desc'] })
    //   .subscribe({
    //     next: (data: PageDTOGestoresResiduosDTO) => {
    //       this.spinnerSrv.loadingHide();
    //       this.gridArray = this.addActionsPermission(this.acuerdoIndirectoInfo.gestoresResiduos ?? []);
    //       this.recordsTotal = data.paginacion?.totalElements ?? 0;
    //     },
    //     error: (err) => {
    //       this.spinnerSrv.loadingHide();
    //       this.snackBarSrv.showSnackBar(
    //         'Ha ocurrido un error al obtener los gestores con acuerdo',
    //         'error'
    //       );
    //       console.log(err);
    //     },
    //   });
  }

  renderPage(event: number) {
    this.pageNumber = event;
    this.buscarGestores();
  }

  onItemsPerPageChange() {
    this.pageSize = this.selectedItemsPerPage;
    this.buscarGestores();
  }
canAccessGestoresAcuerdo(): boolean {
    return (
    this.acuerdoIndirectoInfo?.estado?.id ===1
    );
}
openModalManagers() {
    const codigoDocumento = this.acuerdoIndirectoInfo?.codigoDocumento?.trim()?.toUpperCase();
    if (!codigoDocumento) {
      this.snackBarSrv.showSnackBar('No se ha podido determinar el documento del acuerdo', 'error');
      return;
    }

    const filtro: GestionResiduosFilterDTO = {
      codigoDocumento,
      gestorResiduos: true,
      gestoresResiduosEstado: {
        id: ['2'] // Solo gestores activos
      }
    };

    this.spinnerSrv.loadingShow();
    this.gestoresResiduosService.findAll8(filtro, { page: 0, size: 500, sort: [] }).subscribe({
      next: (data: any) => {
        this.spinnerSrv.loadingHide();
        const existentes = this.acuerdoIndirectoInfo?.gestoresResiduos ?? [];
        const gestoresIncluidos = new Set(existentes.map((g: any) => g?.id).filter((id: any) => !!id));
        const gestoresDisponibles = (data?.datos ?? []).filter((g: any) => !gestoresIncluidos.has(g?.id));

        if (gestoresDisponibles.length === 0) {
          this.snackBarSrv.showSnackBar('Ya no hay mas gestores para poder incluirlos', 'error');
          return;
        }

        const dialogRef = this.dialog.open(IndirectAgreementAddManagerModalComponent, {
          width: '950px',
          maxWidth: '95%',
          maxHeight: '95vh',
          data: {
            acuerdoIndirectoInfo: this.acuerdoIndirectoInfo,
            gestoresDisponibles,
          },
          disableClose: true,
        });

        dialogRef.afterClosed().subscribe((result) => {
          const seleccionados = result?.gestoresSeleccionados ?? [];
          if (!seleccionados.length) {
            return;
          }

          const acuerdoUpdate: any = { ...this.acuerdoIndirectoInfo };
          const actuales = acuerdoUpdate.gestoresResiduos ?? [];
          const byId = new Map<number, any>();
          [...actuales, ...seleccionados].forEach((g: any) => {
            if (g?.id) {
              byId.set(g.id, g);
            }
          });
          acuerdoUpdate.gestoresResiduos = Array.from(byId.values());

          this.spinnerSrv.loadingShow();
          this.acuerdoIndirectoControllerService.updateById(this.acuerdoIndirectoInfo.id, acuerdoUpdate).subscribe({
            next: () => {
              this.spinnerSrv.loadingHide();
              this.snackBarSrv.showSnackBar('Gestores incluidos correctamente', 'success');
              this.refrescarAdheridoEvent.emit(true);
              this.buscarGestores();
            },
            error: () => {
              this.spinnerSrv.loadingHide();
              this.snackBarSrv.showSnackBar('Ha ocurrido un error al incluir gestores en el acuerdo', 'error');
            },
          });
        });
      },
      error: () => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar('Ha ocurrido un error al obtener gestores disponibles', 'error');
      },
    });
  }
  action(element: any) {
     if (element.nameButton == 'delete') {
      this.confirmacionEliminar(element);
    }
  }
  confirmacionEliminar(element?: any): void {
    Swal.fire({
      text: `¿Desea eliminar el gestor?`,
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.eliminarGestor(element);
      }
    });
  }
private buildAcuerdoIndirectoSinGestor(element: any): any {
  const gestoresResiduos = (this.acuerdoIndirectoInfo?.gestoresResiduos ?? []).filter(
    (g: any) => g?.id !== element?.id
  );
  return { ...this.acuerdoIndirectoInfo, gestoresResiduos };
}

eliminarGestor(element?: any) {
  this.spinnerSrv.loadingShow();
  const acuerdoUpdate = this.buildAcuerdoIndirectoSinGestor(element);
  this.acuerdoIndirectoControllerService.updateById(this.acuerdoIndirectoInfo.id, acuerdoUpdate).subscribe({
    next: (value: any) => {
      this.spinnerSrv.loadingHide();
      this.snackBarSrv.showSnackBar('Gestor eliminado correctamente', 'success');
      this.buscarGestores();
      this.refrescarAdheridoEvent.emit(true);

    },
    error: (err) => {
      this.spinnerSrv.loadingHide();
      this.snackBarSrv.showSnackBar('Ha ocurrido un error al eliminar el gestor', 'error');
    }
  });
}
    hasMultiplePages(): boolean {
    const total = this.recordsTotal ?? 0;
    const size = this.pageSize ?? 0;
    return size > 0 && total > size;
  }
}

